// src/providers/cart-provider.tsx
"use client";
import React from "react";
import CartContext from "@/contexts/cart-context";
import type { CartLine, Payment } from "@/lib/types/cart-types";

export default function CartProvider({ children }: { children: React.ReactNode }) {
  const [lines, setLines] = React.useState<CartLine[]>([]);
  const [payments, setPayments] = React.useState<Payment[]>([]);

  const addLine = (l: CartLine) =>
    setLines((prev) => {
      const idx = prev.findIndex((x) => x.productId === l.productId);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + l.qty };
        return next;
      }
      return [...prev, l];
    });

  const removeLine = (productId: string) =>
    setLines((prev) => prev.filter((l) => l.productId !== productId));

  const clear = () => setLines([]);

  const addPayment = (p: Payment) =>
    setPayments((prev) => [...prev, p]);

  const removePayment = (index: number) =>
    setPayments((prev) => prev.filter((_, i) => i !== index));

  const clearPayments = () => setPayments([]);

  const value = React.useMemo(
    () => ({
      lines,
      addLine,
      removeLine,
      clear,
      payments,
      addPayment,
      removePayment,
      clearPayments,
    }),
    [lines, payments]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
